import { observer } from "mobx-react";
import { transHTML } from "../input-element/wf-form-input/util";

export default observer(({ path, form, fieldName }) => {
    const bind = form.$(path).bind();
    let value = transHTML(bind.value)
    return (
        <div style={{display:"inline-block"}}>
            <div id={`${fieldName}span`} {...{ name: `${fieldName}span` }} dangerouslySetInnerHTML={{ __html: `<div class="wea-cube-ckeditor-content">${bind.value}</div>` }} />
            <input type="hidden" id={fieldName} name={fieldName} value={value} />
        </div>
    )
})


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/textarea-element/ReadonlyText.tsx